import { FlexColumn } from 'components/base'
import { AssetIcon, AssetWrapper, InputContent, LoaderWrapper } from './styled'
import { assetsListBySymbol } from 'abis/set/asset-icons'
import { BoldAmount, CurrencyValue, CurrencyValueContainer, SectionTitle } from '../../styles'
import Big from 'big.js'
import { DEFAULT_DECIMAL_DISPLAY_POSITION } from 'app-constants'
import { GLOBAL_COLORS } from 'theme'
import { valueToCurrencyFormat } from 'utils'
import { BalanceLoader } from 'components/balance-loader'
import { transactionAmountFormatter } from 'components/notifications/service'
import { OutputAssetType } from '../../storage/interface'

interface ReceivedComponentProps {
  receivedSymbol: string
  output: OutputAssetType
  isDebounce: boolean
}

export const ReceivedComponent = ({
  receivedSymbol,
  output,
  isDebounce,
}: ReceivedComponentProps) => {
  const symbol = receivedSymbol.toUpperCase()
  const image = assetsListBySymbol[symbol].icon
  const outputAmount = output.amount ?? Big(0)
  const outputValue = output.value ?? Big(0)

  const formattedOutputAmount = !outputAmount.eq(0)
    ? transactionAmountFormatter(outputAmount.toString())
    : outputAmount.toFixed(DEFAULT_DECIMAL_DISPLAY_POSITION)

  return (
    <FlexColumn>
      <SectionTitle>You receive</SectionTitle>
      <InputContent>
        <AssetWrapper>
          <AssetIcon src={image} />
          <BoldAmount>{symbol}</BoldAmount>
        </AssetWrapper>
        <FlexColumn>
          <FlexColumn>
            <BoldAmount color={outputAmount.eq(0) ? GLOBAL_COLORS.investCurrencyGrey : undefined}>
              {isDebounce ? (
                <LoaderWrapper>
                  <BalanceLoader gray />
                </LoaderWrapper>
              ) : (
                formattedOutputAmount
              )}
            </BoldAmount>
          </FlexColumn>
          <CurrencyValueContainer>
            <CurrencyValue>{!isDebounce && valueToCurrencyFormat(outputValue)}</CurrencyValue>
          </CurrencyValueContainer>
        </FlexColumn>
      </InputContent>
    </FlexColumn>
  )
}
